// App.js
import React from 'react';
import './App.css';
import ChatbotApp from './components/ChatbotApp';

const App = () => {
  return (
    <div>
      <ChatbotApp/>
    </div>
  );
};

export default App;
